import { Box, Button, Grid2 } from '@mui/material'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import CustomDivider from '../../shared/utils/CustomDivider'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { useToaster } from '../../shared/utils/ToasterProvider'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { TextFormField } from '../../shared/components/formfields/TextFormField'
import { Grid_Gap } from '../../shared/constants'
import useAuthStore from '../../store/useAuthStore'
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField'
import AddPayoutForm from '../admin/AddPayoutForm'
import MainDialogBox from '../../shared/components/Dialog/MainDialogBox'
import { useDialog } from '../../shared/hook/useDialog'
import AddMarketingForm from '../admin/AddMarketingForm'
import { useState } from 'react'
import { AutoCompleteField } from '../../shared/components/formfields/AutoCompleteField'
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate'
import { useApartmentColumnsWithDialog } from '../../shared/utils/useApartmentColumnsWithDialog'
import { useClusterOptions } from '../admin/option/ClusterOption'
import api from '../../assets/nodeApi/axiosInstance'


const CommonTermAndCondtion = ({ apartmentRow, isloadingApartment }) => {
    const { apartmentColumns, viewApartment, dialogJSX } = useApartmentColumnsWithDialog();
    const [filters, setFilters] = useState({});
    const { user, token } = useAuthStore()
    const { open: openPayout, handleClickOpen: handleClickOpenPayout, handleClose: hadlePayoutClose } = useDialog();
    const { open: openMarketing, handleClickOpen: handleOpenMarketing, handleClose: handleCloseMarketing } = useDialog();
    const { AddedClusterOptions } = useClusterOptions()

    const uniqueTermsStatusOptions = [
        ...new Set(
            apartmentRow?.map(item => item?.terms_status).filter(Boolean)
        ),
    ].map((status, index) => ({
        id: index + 1,
        label: status,
        value: status,
    }));
    const ApartmentOption = apartmentRow?.map((item, index) => ({
        id: item?.id,
        value: item?.apartment_name,
        label: item?.apartment_name

    })) || [];
    const queryClient = useQueryClient();
    const validationSchema = Yup.object().shape({
        apartment_id: Yup.string().required('Apartment is required'),
        security_deposit: Yup.number()
            .typeError('Security deposit must be a number')
            .required('Security deposit is required')
            .min(0, 'Security deposit cannot be negative'),
        terms_conditions: Yup.string().required('Terms and conditions are required')
    });
    const initialValues = {
        apartment_id: "",
        security_deposit: "",
        terms_conditions: ""
    };
    const { showToaster } = useToaster();
    const mutation = useMutation({
        mutationFn: (formData) => api.post("apartment-terms", formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        ),
    });
    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        const obj = {
            apartment_id: values.apartment_id,
            security_deposit: values.security_deposit,
            terms_conditions: values.terms_conditions
        }
        mutation.mutate(obj, {
            onSuccess: (response) => {
                showToaster('Success', response?.data?.message, 'success')
                queryClient.invalidateQueries({ queryKey: ['apartments/by-cityorzone'] });
                queryClient.invalidateQueries({ queryKey: ['apartments/by-coordinator'] });
                queryClient.invalidateQueries({ queryKey: ['apartment-terms/by-apartment'] });
                resetForm();
            },
            onError: (error) => {
                const statusCode = error?.response?.status;
                if (statusCode === 401) {
                    showToaster("Unauthorized. Please log in again.", 'Error', 'error');
                } else if (statusCode === 409) {
                    showToaster(error?.response?.data?.message, 'Error', 'error');
                } else if (statusCode === 500) {
                    showToaster("Server Error. Please try again later.", 'Error', 'error');
                } else {
                    showToaster("Something went wrong", 'Error', 'error');
                }
            },
            onSettled: () => {
                setSubmitting(false);
            },
        });

    }


    return (
        <Box>
            <CustomDivider />
            <NormalContainerWithHeader headerText={"Add Term And Condition"}>
                <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
                    {({resetForm}) => (
                        <Form>
                            <Grid2 container spacing={Grid_Gap}
                                sx={{ placeItems: "start" }}
                            >
                                <Grid2 children size={{ xs: 12, sm: 6, md: 4 }}>
                                    <Field
                                        name="apartment_id"
                                        component={IdAutoCompleteField}
                                        options={ApartmentOption}
                                        label="Select Apartment"
                                        isRequired={true}
                                        isLoading={isloadingApartment}
                                    />
                                </Grid2>
                                <Grid2 children size={{ xs: 12, sm: 6, md: 4 }}>
                                    <Field
                                        name="security_deposit"
                                        component={TextFormField}
                                        label="Enter Security Deposit"
                                        isRequired={true}
                                        type={"number"}
                                    />
                                </Grid2>
                                <Grid2 children size={{ xs: 12, sm: 6, md: 4 }}>
                                    <Field
                                        name="terms_conditions"
                                        component={TextFormField}
                                        label="Enter Term And Condition"
                                        isRequired={true}
                                        multiline
                                        row={4}
                                    />
                                </Grid2>

                            </Grid2>
                            <CustomDivider />
                            <Grid2 container spacing={Grid_Gap} sx={{ display: "flex", justifyContent: "end" }} >
                                <Grid2 children size={{ xs: 12, sm: 3 }}>
                                    <Button variant='outlined' fullWidth onClick={resetForm}>Cancel</Button>
                                </Grid2>
                                <Grid2 children size={{ xs: 12, sm: 3 }}>
                                    <Button variant='contained' type="submit" fullWidth>Submit</Button>
                                </Grid2>
                                {user.role !== "Admin" && user.role !== "Zonal Coordinator" && (
                                    <>
                                        <Grid2 children size={{ xs: 12, sm: 6, md: 3 }}>
                                            <Button variant='contained' fullWidth onClick={handleClickOpenPayout}>Add Payout</Button>
                                        </Grid2>
                                        <Grid2 children size={{ xs: 12, sm: 6, md: 3 }}>
                                            <Button variant='contained' fullWidth onClick={handleOpenMarketing}>Add Marketing</Button>
                                        </Grid2>
                                    </>
                                )}

                            </Grid2>
                        </Form>
                    )}
                </Formik>
                <CustomDivider />
            </NormalContainerWithHeader>
            <CustomDivider />
            <TableFilterTemplate
                title="Apartment List"
                columns={apartmentColumns}
                rowsData={apartmentRow || []}
                isLoading={isloadingApartment}
                // filterInitialValues={filters}
                // filterReset={() => setFilters({})}
                // onApplyFilters={(f) => setFilters(f)}
                // filters={filters}
                dataGridProps={{
                    onRowClick: (params) => viewApartment(params.row)
                }}
                // renderFilterFields={() => (
                //     <>
                //         <Grid2 children size={12}>
                //             <Field
                //                 name="terms_status"
                //                 component={AutoCompleteField}
                //                 options={uniqueTermsStatusOptions}
                //                 label="Select Status"
                //                 isRequired={true}
                //                 isLoading={isloadingApartment}
                //             />

                //         </Grid2>
                //         <Grid2 children size={12}>
                //             <Field
                //                 name="cluster_id"
                //                 component={AutoCompleteField}
                //                 options={AddedClusterOptions.options}
                //                 label="Select Cluster"
                //                 isRequired={true}
                //                 isLoading={AddedClusterOptions.isLoading}
                //             />

                //         </Grid2>

                //     </>
                // )}
            />

            {dialogJSX}

            <MainDialogBox open={openPayout} handleClose={hadlePayoutClose} width={"30%"}>
                <AddPayoutForm hadlePayoutClose={hadlePayoutClose} ApartmentOption={ApartmentOption} isLoadingApart={isloadingApartment} />
            </MainDialogBox>

            <MainDialogBox open={openMarketing} handleClose={handleCloseMarketing} width={"30%"}>
                <AddMarketingForm handleCloseMarketing={handleCloseMarketing} ApartmentOption={ApartmentOption} isLoadingApart={isloadingApartment} />
            </MainDialogBox>

        </Box>
    )
}

export default CommonTermAndCondtion 